import React from 'react';
import USDatasheet from '../usds/USDatasheet';

// US-format datasheet preview — thin wrapper over the US datasheet kit (fixture / housing / fitting + housing).
export default function USDatasheetPreview({ sheet, pageId }) {
  return <USDatasheet sheet={sheet} pageId={pageId} />;
}
